module.exports = "notifications-bell"